import * as React from "react";
const SvgEllipse = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 6, height: 6, viewBox: "0 0 6 6", fill: "none", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 3, cy: 3, r: 3, fill: "currentColor" }));
export default SvgEllipse;
